declare const noDataTag: unique symbol

type NoDataTag = typeof noDataTag

class NoData<T> {
  /**
   * Phantom type to ensure NoData is nominally typed,
   * and nothing else can be assigned to it or used in its place.
   */
  declare private readonly __noDataTag: NoDataTag
  label = ''

  constructor(public value: T) {}
}

export const isNoOpMetric = <T>(value: unknown): value is NoData<T> => {
  return value instanceof NoData
}

export const NoOpMetric = {
  Number: new NoData(NaN),
  String: new NoData('')
}

export type { NoData }
